module.exports = __webpack_public_path__ + "img/digitalsocialhour-square.3ac33cc7.png";